<template>
	<div
		class="heardBox"
		:class="types == 1 ? 'boxs' : types == 2 ? 'boxs1' : ''"
		:style="{ 'background-color': bag ? bag : '', borderBottom: bag ? '1px solid #EFEFEF' : 'none' }"
	>
		<div class="topHead">
			<div class="Icon" @click="goFn">
				<img class="supHove2" :src="$imgUrl + appLogo?.configValue" alt="" />
			</div>
			<div class="topHeadRig" v-if="!isLogin">
				<div class="topHeadBtn supHove3" @click="btnFn(0)" :class="tabFlag == 0 ? 'active' : ''">公司简介</div>
				<div class="topHeadBtn supHove3" :class="tabFlag == 1 ? 'active' : ''" @click="btnFn(1)">线上服务</div>
				<div class="topHeadBtn supHove3" :class="tabFlag == 2 ? 'active' : ''" @click="btnFn(2)">模拟机考</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
	name: 'brieHeader',
	data() {
		return {};
	},
	computed: {
		...mapState(['tabFlag', 'appLogo']),
		isLogin() {
			let isLogin = localStorage.getItem('token') ? true : false;
			return isLogin;
		}
	},
	props: ['bag', 'types'],
	methods: {
		...mapMutations(['tabFn']),
		btnFn(type) {
			this.tabFn(type);
			if (type == 0) {
				this.$router.push({
					path: 'briefIntr'
				});
			} else if (type == 2) {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: 'taotiziyuan'
					});
				} else {
					this.$router.push({
						path: 'login'
					});
				}
			} else {
				this.$router.push({
					path: 'login'
				});
			}
		},
		goFn() {
			if (localStorage.getItem('token')) {
				this.$router.push({
					path: 'home'
				});
			} else {
				this.tabFn(0);
				this.$router.push({
					path: 'briefIntr'
				});
			}
		}
	},
	mounted() {
		console.log(this.types, 88877777);
	}
};
</script>
<style lang="scss" scoped>
.heardBox {
	height: 60px;
	background: #ffffff;
	box-sizing: border-box;
	.topHead {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		.Icon {
			height: 32px;
			img {
				height: 100%;
				cursor: pointer;
			}
		}
		.topHeadRig {
			height: 36px;
			display: flex;
			.topHeadBtn {
				width: 85px;
				height: 36px;
				display: flex;
				justify-content: center;
				line-height: 36px;
				color: #000000;
				border-radius: 7px;
				margin-right: 17px;
				cursor: pointer;
			}
			.active {
				background: #000000;
				color: #fff;
			}
		}
	}
}
.boxs {
	background: rgba(#000000, 0.1);
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	z-index: 999999;
}
.boxs1 {
	background: #fff;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	z-index: 999999;
}
</style>
